import {Box, Button, Flex, Heading,
  HStack, IconButton,Image, Spacer, Stack, Text, useColorMode} from "@chakra-ui/react";
import {AxiosResponse} from "axios";
import { IoContrast, IoExpand, IoSunny  } from "react-icons/io5";
import {useQuery} from "react-query";
import {matchRoutes, useLocation, useNavigate} from "react-router-dom";

import {getCurrentUser as apiGetCurrentUser} from "../shared/Api";
import {useAuthentication} from "../shared/hooks/AuthenticationProvider";
import {useFont} from "../shared/hooks/FontProvider";
import {useTheme} from "../shared/hooks/ThemeProvider";
import {Authority, Paths} from "../shared/model/Constants";
import {UserDto} from "../shared/model/Dto";
import {authenticationKeys} from "../shared/QueryKeys";

const HeaderPelex = () => {
  const authentication = useAuthentication();
  const navigate = useNavigate();
  const { colorMode, toggleColorMode } = useColorMode()

  const { pathname } = useLocation();

  //const [theme, setTheme] = useState<AppTheme>(getTheme());
  const themeContext = useTheme();
  const fontContext = useFont();

  // To prevent speech test session from expiring
  // only one refetchInterval works at a time
  const currentUserQuery = useQuery<AxiosResponse<UserDto>, Error>(
    authenticationKeys.currentUser(),
    apiGetCurrentUser,
    {
      // 2.5 min
      refetchInterval: (data) => (data !== undefined &&
       ( matchRoutes([{path:Paths.SPEECH_TEST}], pathname) || matchRoutes([{path:Paths.AUTOMATED_TEST}], pathname) )
		? 1000 * 150 : false),
      refetchIntervalInBackground: true,
      refetchOnMount: "always",
      retry: ( matchRoutes([{path:Paths.SPEECH_TEST}], pathname) || matchRoutes([{path:Paths.AUTOMATED_TEST}], pathname) )
		? true : false
    }
  );

  function navigateHome() {
    navigate(Paths.HOME);
  }

  function loggedIn(){
    return (authentication.currentUserQuery && (!authentication.currentUserQuery.isError &&
      authentication.currentUserQuery.data?.status !== 401))
  }

  function loggedInAs(authority: Authority){
    return (authentication.currentUserQuery && (!authentication.currentUserQuery.isError &&
        authentication.currentUserQuery.data?.status !== 401) &&
      (authentication.currentUserQuery.data?.data?.authorities?.includes(authority) ||
      authentication.currentUserQuery.data?.data?.authorities?.includes(Authority.ROLE_ADMIN)))
  }

  function toggleBWMode() {
      sessionStorage.setItem('theme', sessionStorage.getItem('theme')==="basic"?"bwContrast":"basic");
      //setTheme(getTheme());
      themeContext.refreshTheme();
  }

  function switchFontSize() {
      sessionStorage.setItem('fontSize', sessionStorage.getItem('fontSize')==="bigFont"?"basic":"bigFont");
      fontContext.refreshFont();
  }

  const isTest = matchRoutes([{path:Paths.TESTS_PUBLIC_ID}], pathname) ||
      matchRoutes([{path:Paths.SPEECH_TEST}], pathname) ||
      matchRoutes([{path:Paths.AUTOMATED_TEST}], pathname);
  return (
    <>{
      <Box bg={themeContext.theme.BG_SECONDARY} padding="1"
          filter= {'grayscale('+themeContext.theme.IMG_GRAYSCALE+') contrast('+themeContext.theme.IMG_CONTRAST+')'}>
        <Flex align="center" flexWrap="wrap" justifyContent="flex-start">
          <HStack color={themeContext.theme.TEXT_SECONDARY}>
            <Image src="/images/firma-horizontal-dos-lineas-reverso.png" height="4rem"/>
            <Image src="/images/LOGO PELEX HORIZONTAL FONDO NEGRO.png"  height="2.5em" paddingX="1em"/>
            <Heading as="h1" size={fontContext.font.midHeading} fontSize={fontContext.font.p}>
              Dominio Lingüístico
            </Heading>
          </HStack>
          <Spacer />
          { loggedIn() ?
            <><Text paddingX={5} color={themeContext.theme.TEXT_SECONDARY}
             fontWeight={fontContext.font.weight}
             fontSize={fontContext.font.p}>
              {authentication.currentUserQuery?.data?.data?.name}
            </Text>
              { loggedInAs(Authority.ROLE_ADMIN) &&
                <Box>
                  <Button colorScheme={themeContext.theme.COLOR_SCHEME}
                  fontWeight={fontContext.font.weight}
                               fontSize={fontContext.font.p}
                   onClick={()=>navigate(Paths.ADMIN)}>
                    Administrador
                  </Button>
                </Box>
              }
              { !isTest && loggedInAs(Authority.ROLE_JUDGE) &&
                <Box>
                  <Button colorScheme={themeContext.theme.COLOR_SCHEME}
                  fontWeight={fontContext.font.weight}
                               fontSize={fontContext.font.p}
                                onClick={()=>navigate(Paths.JUDGE_CANDIDATES)}>
                    Ver candidatos
                  </Button>
                </Box>
              }
              { !isTest && loggedInAs(Authority.ROLE_TEACHER) &&
                <Box>
                  <Button colorScheme={themeContext.theme.COLOR_SCHEME}
                  fontWeight={fontContext.font.weight}
                               fontSize={fontContext.font.p}
                                onClick={()=>navigate(Paths.TEACHER_LICENSES_INST)}>
                    Ver licencias
                  </Button>
                </Box>
              }
              { !isTest && loggedInAs(Authority.ROLE_TEACHER) &&
                <Box>
                  <Button colorScheme={themeContext.theme.COLOR_SCHEME}
                  fontWeight={fontContext.font.weight}
                               fontSize={fontContext.font.p}
                                onClick={()=>navigate(Paths.TEACHER_LICENSES_INST_UNIBAND)}>
                    Ver licencias Unibanda
                  </Button>
                </Box>
              }
              { !isTest && loggedInAs(Authority.ROLE_TEACHER) &&
                authentication?.currentUserQuery?.data?.data.institution !== 'Aliarse' &&
                <Box paddingLeft={5}>
                  <Button  onClick={()=>navigate(Paths.TEACHER_CANDIDATES)}>
                    Ver progreso
                  </Button>
                </Box>
              }
              <Box paddingLeft={5}>
                <Button colorScheme={themeContext.theme.COLOR_SCHEME}
                  fontWeight={fontContext.font.weight}
                               fontSize={fontContext.font.p}
                                onClick={navigateHome}>
                  Inicio
                </Button>
              </Box>
              {!isTest && <Box paddingLeft={5}>
                <Button colorScheme={themeContext.theme.BG_INACTIVE}
                _dark={{ bgColor: "gray.800" }}
                  fontWeight={fontContext.font.weight}
                               fontSize={fontContext.font.p}
                        onClick={() => authentication.logoutMutation?.mutate(null)}>
                  Cerrar sesión
                </Button>
              </Box>
              }
            </>
            : <> { matchRoutes([{path:Paths.ERROR}], pathname) &&
              <Box paddingX={5}>
                <Button colorScheme={themeContext.theme.COLOR_SCHEME}
                  fontWeight={fontContext.font.weight}
                               fontSize={fontContext.font.p}
                                onClick={navigateHome}>
                  Inicio
                </Button>
              </Box>
            }
            </>
          }
          <Stack paddingLeft="1em" direction="row" >
            <IconButton aria-label={"Modo oscuro / claro"} icon={ <IoSunny size="1.5em" />}
                _dark={{ bgColor: "gray.800" }}
                  onClick={toggleColorMode}/>
            <IconButton aria-label={"Blanco y negro"} icon={ <IoContrast size="1.5em" />}
                _dark={{ bgColor: "gray.800" }}
                  onClick={toggleBWMode}/>
            <IconButton aria-label={"Letra grande"} icon={ <IoExpand size="2em" />}
                _dark={{ bgColor: "gray.800" }}
                  onClick={switchFontSize}/>
          </Stack>
        </Flex>
      </Box>
    }
    </>
  );
};

export default HeaderPelex;
